module.exports = __webpack_public_path__ + "img/FPT09.c176d83f.svg";